import numeral from 'numeral';

export default {

  format: (amount: number, symbol = '£') => `${symbol}${numeral(amount).format('0,0.00')}`,

};
